import React, { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Router, Switch, Route, useLocation } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import history from './History';
import FeedBack from './components/FeedBack/FeedBack';
import ChatBot from './components/ChatBot/ChatBot';
import ScrollToTop from './components/Common/ScrollToTop';
import PageViewTracker from './components/Common/PageViewTracker';

import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import CssBaseline from '@material-ui/core/CssBaseline';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';

import MainPortalRoutes from './subdomains/MainPortalRoutes';
import SubdomainRoutes from './subdomains/SubdomainRoutes';
import LiaRoutes from './subdomains/LiaRoutes';
import { getSubdomain } from './subdomains/portal';

/** The floating LIA launcher, except on LIA's own page, which already has the chat. */
function FloatingAssistant({ subdomain }) {
  const { pathname } = useLocation();
  const onLiaPage = pathname === '/lia' || (subdomain === 'lia' && pathname === '/');
  return onLiaPage ? null : <ChatBot />;
}

function App() {
  // Read once: the host doesn't change for the life of the page.
  const [subdomain] = useState(getSubdomain);
  const { t } = useTranslation();

  return (
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router history={history}>
          <ScrollToTop />
          <PageViewTracker />
          <Switch>
          <Route exact path="/chatbot"><ChatBot standalone /></Route>
          <Route>
          <a className="mof-skip-link" href="#main-content">
            {t('Skip to main content')}
          </a>
          <Navbar subdomain={subdomain} />
            <main id="main-content" tabIndex={-1}>
              {!subdomain ? (
                <MainPortalRoutes />
              ) : subdomain === 'lia' ? (
                <LiaRoutes subdomain={subdomain} />
              ) : (
                <SubdomainRoutes subdomain={subdomain} />
              )}
            </main>
          <Footer subdomain={subdomain} />
          <div className="mof-no-print">
            <FeedBack />
            <FloatingAssistant subdomain={subdomain} />
          </div>
          </Route>
          </Switch>
        </Router>
      </ThemeProvider>
      </HelmetProvider>
    </I18nextProvider>
  );
}

export default App;
